import styled from "styled-components";
export const ChatHeaderStyle = styled.div`
  border-bottom: 1px solid #eff2f5;
  padding: 10px;
`;
